import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { useApiFormAsset, useApiListAsset } from '../../../../../../api-new/state/content'
import { Menu, MenuDelete, MenuEdit, MenuItem, MenuLink } from '../../../../../../shared/menu/menu'
import { IconAdd, IconList, IconRecycle, IconVersion } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { AssetAdd } from './asset-add'
import { Purge } from '../../../../../../shared/page/page-purge'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { AssetEdit } from './asset-edit'
import { AssetVersionlist } from './asset-version-list'
import { AssetListRecycle } from './asset-list-recycle'
import { Delete } from '../../../../../../shared/page/page-delete'

export const AssetList = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListAsset = useApiListAsset()

  const handleReady = () => apiListAsset.get(`${nodeID}/node`)
  const handleDestroyed = () => apiListAsset.init()

  const HeaderMenu = () =>
    <Menu>
      <MenuLink Icon={IconAdd} text="new asset" to={`${url}/add`} show={true} />
      <MenuLink Icon={IconRecycle} text="recycle" to={`${url}/recycle`} show={true} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="assets">
        <CardFullHeightScrollY title="assets" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAsset} onReady={handleReady} onDestoryed={handleDestroyed} pollInterval={5000}>
            <ColumnDateTime field="createdAt" />
            <ColumnDateTime field="updatedAt" />
            <ColumnText field="name" />
            <ColumnSize field="length" header="Size" />
            <ColumnText field="version" header="Active Version" />
            <ColumnText field="versionCount" header="Versions" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="notes" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/edit/${row.id}`} show />
                  <MenuItem Icon={IconVersion} text="versions" to={`${url}/edit/${row.id}/version`} show />
                  <MenuDelete to={`${url}/edit/${row.id}/${row.id}/delete`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/add`}>
        <AssetAdd parentURL={url} nodeID={nodeID} />
      </Route>

      <Route path={`${url}/edit/:assetID`}>
        <AssetEdit />
      </Route>

      <Route path={`${url}/edit/:assetID/version`}>
        <AssetVersionlist />
      </Route>

      <Route path={`${url}/edit/:assetID/:deleteID/delete`}>
        <Delete useApiForm={useApiFormAsset} titleParam="name" successPath={url} />
      </Route>

      <Route path={`${url}/recycle`}>
        <AssetListRecycle nodeID={nodeID} />
      </Route>

      <Route path={`${url}/recycle/:purgeID/purge`}>
        <Purge useApiForm={useApiFormAsset} titleParam="name" successPath={`${url}/recycle`} />
      </Route>
    </React.Fragment>
  )
}
